import React from 'react';

import CustomResult from 'client/components/Result/CustomResult/CustomResult';
import { isObject } from 'utils/objectManipulate';

export default function GameCustomResult({ gameResultPayload, latestRecord }) {
    const parseData = data => (isObject(data) ? data : JSON.parse(data));
    const { pageInfo, gameResult } = gameResultPayload ? parseData(gameResultPayload) : {};
    return (
        <CustomResult
            gameResult={gameResultPayload}
            page={pageInfo}
            result={gameResult}
            latestRecord={latestRecord}
        />
    );
}
